import React                    from 'react';
import { arrayYqty as tooltip } from 'pu-data/Tooltips';
import TextComponent            from './TextComponent';

const ArrayYQty = (props) => {
  const name = 'array_y_qty';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label="# of up in Y"
      name={name}
      value={parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayYQty.defaultProps = {};

export default ArrayYQty;
